import React from 'react';
import { useSelector } from 'react-redux';
import { Box, FormControlLabel, FormGroup, Grid, IconButton, Paper, Switch, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useMutateMfaHandler } from '../dataHandlers/mutateMfaHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const MfaSettingSection = () => {
  const org = useSelector((state) => state.org.org);
  const { settings: msg } = useTranslatedMessages();
  const { onSubmit, isPending: mfaLoading } = useMutateMfaHandler();

  const handleMfaToggle = () => {
    const updatedEnable2FA = !org?.settings?.account_settings?.is_mfa_enabled;
    onSubmit(updatedEnable2FA);
  };

  return (
    <Paper elevation={0} sx={{ pl: '1rem' }}>
      <Grid container>
        <Grid size={6}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Switch
                  checked={org?.settings?.account_settings?.is_mfa_enabled || false}
                  disabled={mfaLoading}
                  onChange={handleMfaToggle}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {msg.mfa.label}
                  <Tooltip title={msg.mfa.tooltip}>
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              labelPlacement="start"
              sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default MfaSettingSection;
